import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { loadersBuilder, logoutBuilder } from '@modules/builders';

import globalActions from './actions';
import initialState from './state';
import type * as GlobalTypes from './types';

export const globalReducer = createReducer(initialState, builder => {
  builder.addCase(globalActions.setCaptcha, (state, action) => {
    state.captcha = action.payload;
  });

  builder.addCase(globalActions.setShowCaptcha, (state, action) => {
    state.isShowCaptcha = action.payload;
  });

  builder.addCase(globalActions.resetCaptcha, state => {
    state.captcha = '';
    state.isShowCaptcha = false;
  });

  builder.addCase(globalActions.setLang, (state, action) => {
    state.lang = action.payload;
  });

  builder.addCase(globalActions.setProtect, (state, action) => {
    state.protect = action.payload;
  });

  builder.addCase(globalActions.setFingerPrintData, (state, action) => {
    state.fingerPrintData = action.payload;
  });

  builder.addCase(globalActions.setScheme, (state, action) => {
    state.scheme = action.payload;
  });

  builder.addCase(globalActions.getCountries.fulfilled, (state, action) => {
    state.countries = action.payload.data;
  });

  builder.addCase(globalActions.getStates.fulfilled, (state, action) => {
    state.states = action.payload.data;
  });

  builder.addCase(globalActions.getDataByIp.fulfilled, (state, action) => {
    state.dataByIp = action.payload.data.country;
  });

  builder.addCase(globalActions.getCurrencies.fulfilled, (state, action) => {
    state.currencies = action.payload.data;
  });

  builder.addCase(globalActions.getIbanPurposes.fulfilled, (state, action) => {
    state.ibanPurposes = action.payload.data;
  });

  builder.addCase(globalActions.getCalcStart.fulfilled, (state, action) => {
    state.calcId = action.payload.data.xCalcId;
  });

  builder.addCase(globalActions.setZHModalType, (state, action) => {
    state.zhModalType = action.payload;
  });

  builder.addCase(globalActions.closeZHModal, state => {
    delete state.zhModalType;
  });

  builder.addCase(globalActions.redirectTo, (state, action) => {
    state.redirect = typeof action.payload === 'string' ? { to: action.payload } : action.payload;
  });

  builder.addCase(globalActions.clearRedirect, state => {
    state.redirect = {};
  });

  builder.addMatcher(
    isAnyOf(globalActions.checkUKUserByIp.fulfilled, globalActions.getDataByIp.fulfilled),
    (state, action) => {
      state.isUk = action.payload.data.country.code === CONST.ukCountryCode;
    }
  );

  logoutBuilder(initialState, builder, ['scheme', 'dataByIp', 'isUk']);
  loadersBuilder('global', builder);
});

export { globalActions, GlobalTypes };
